import { useMutation, useQuery } from "react-query";
import {
  createBusiness,
  createPin,
  createSign,
  getAccBalance,
  getBankCode,
  getBene,
  getFlow,
  getSignatories,
  getUser,
  transfer,
  validateBank,
} from "../api/account";
import * as queryKey from "../queryKeys";

export const useGetAccBalance = (options = {}) => {
  const { data, isLoading, refetch } = useQuery(
    queryKey.ACC_BALANCE,
    getAccBalance,
    {
      ...options,
      refetchInterval: 10_000,
    }
  );

  return { data, isLoading, refetch };
};

export const useGetSignatories = (signatory = "", options = {}) => {
  const { data, isLoading, refetch } = useQuery(
    [queryKey.GET_SIGNATORIES, signatory],
    getSignatories,
    {
      ...options,
    }
  );

  return { data, isLoading, refetch };
};

export const useGetUser = (options = {}) => {
  const { data, isLoading, refetch } = useQuery(queryKey.GET_USER, getUser, {
    ...options,
    refetchInterval: 10_000,
  });

  return { data, isLoading, refetch };
};

export const useCreatePin = (options = {}) => {
  const { mutate, isLoading } = useMutation(createPin, {
    mutationKey: queryKey.CREATE_PIN,
    ...options,
  });

  return { mutate, isLoading };
};

export const useCreateSign = (options = {}) => {
  const { mutate, isLoading } = useMutation(createSign, {
    mutationKey: queryKey.CREATE_SIGN,
    ...options,
  });

  return { mutate, isLoading };
};

export const useCreateBusiness = (options = {}) => {
  const { mutate, isLoading } = useMutation(createBusiness, {
    mutationKey: queryKey.CREATE_BUSINESS,
    ...options,
  });

  return { mutate, isLoading };
};

export const useTransfer = (options = {}) => {
  const { mutate, isLoading } = useMutation(transfer, {
    mutationKey: queryKey.TRANSFER,
    ...options,
  });

  return { mutate, isLoading };
};

export const useValidateBank = (options = {}) => {
  const { mutate, isLoading, data } = useMutation(validateBank, {
    mutationKey: queryKey.VALIDATE_BANK,
    ...options,
  });
  return { mutate, isLoading, data };
};

export const useGetBene = (options = {}) => {
  const { data, isLoading, refetch } = useQuery(queryKey.GET_BENE, getBene, {
    ...options,
  });

  return { data, isLoading, refetch };
};

export const useGetBankCode = (options = {}) => {
  const { data, isLoading } = useQuery(queryKey.BANK_CODE, getBankCode, {
    ...options,
  });

  return { data, isLoading };
};

export const useGetFlow = (options = {}) => {
  const { data, isLoading } = useQuery(queryKey.GET_FLOW, getFlow, {
    ...options,
  });

  return { data, isLoading };
};
